import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Pagination } from 'swiper'
import CardMain from '../../share/Components/Card/CardMain'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useEffect } from 'react'
import useFetch from '../../_services/fetch'
import { RaytebRequests } from '../../_services'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../storeManager/ReducerType'
import { LoginInterface } from '../../Interfaces/LoginInterface'

const Main = () => {
  SwiperCore.use([Autoplay])
  const user = useSelector<ReducerType, LoginInterface>((n) => n.reducerUser)
  const device = useSelector<ReducerType, DeviceModeInterface>(
    (n) => n.reducerDevice
  )
  const slider = useFetch<SliderViewModel[], unknown, { type: 0 | 1 }>({
    request: RaytebRequests.Slider_GET({ token: user.token }),
  })

  useEffect(() => {
    slider.reFetch(null, { type: device.Desktop || device.Laptop ? 1 : 0 })
  }, [device])
  return (
    <>
      {slider.isLoading ? (
        <Skeleton height={300} />
      ) : (
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          spaceBetween={50}
          slidesPerView={1}
          autoplay={true}
          loop={true}
        >
          {slider.result?.map((n, i) => (
            <SwiperSlide key={i}>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={n.link ? n.link : '#'}
              >
                <img src={n.url} />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      <div className='grid items-center justify-items-center grid-cols-3 gap-3 px-2 md:px-12 pt-5'>
        <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-users-1'}
          path={'/Patient'}
        >
          بیماران
        </CardMain>
        <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-wallet'}
          path={'/Appointment'}
        >
          نوبت امروز
        </CardMain>
        <CardMain
          path={'/TicketRequest'}
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-online-visit'}
        >
          مشاوره آنلاین
        </CardMain>
        <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-calendar'}
          path={'/TimeSheet'}
        >
          برنامه کاری
        </CardMain>
        <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-user-profile'}
        >
          ارجاعات
        </CardMain>
        <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-sign-in'}
          path={'/ManagementDashboard'}
        >
          داشبورد مدیریتی
        </CardMain>
        <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-field'}
          path={'/Reports'}
        >
          گزارش ها
        </CardMain>
        <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-cog'}
          path={'/setting'}
        >
          تنظیمات
        </CardMain>
        <CardMain
          path={'/Support'}
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-support'}
        >
          پشتیبانی آنلاین
        </CardMain>
        {/* <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-insurance'}
          path={'/Insurances'}
        >
          بیمه ها
        </CardMain> */}
        {/* <CardMain
          className={
            'bg-white w-full py-4  px-2 rounded-md  text-primary cursor-pointer'
          }
          classIcon={'rayteb-download'}
          path={'/Downloads'}
        >
          دانلود ها
        </CardMain> */}
      </div>
    </>
  )
}

export default Main
